exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".component-detail-header .vcp-playing{z-index:20}", ""]);

// exports
